module.exports = __webpack_public_path__ + "static/media/ivn_gift_colored.e6fd21c3.svg";